export const fetchWithAuth = (url, options = {}) => {
  const token = localStorage.getItem("token");

  const headers = {
    ...(options.headers || {}),
  };

  // [EXPERT_FIX]: Validar token antes de enviar
  if (token && token !== "null" && token !== "undefined") {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });
};

/* export const API_URL =
  process.env.REACT_APP_API_URL_DEV + ":" + process.env.REACT_APP_API_PORT; */

const rawApiUrl = process.env.REACT_APP_API_URL;
export const API_URL = (rawApiUrl && rawApiUrl !== "undefined") ? rawApiUrl : "https://sge.sgeyyt.com";
//export const API_URL = "https://sgeyyt.com";
